import { times } from "lodash";
import { ValidationError } from 'yup'

export const getValueByPath = (obj, path) => {
    const props = path.split('.');
    let value = obj;

    for(let i = 0; i < props.length; i++) {
        const prop = props[i];

        if(Array.isArray(value) &&  /^\d$/.test(prop)) {
            //if the current value is an array and the property is a number
            value = value[parseInt(prop)];
        } else if(typeof value === "object" && value !== null && value.hasOwnProperty(prop)) {
            //if the value is an object and this properties exits
            value = value[prop];
        } else {
            //otherwise returns undefined
            return undefined;
        }
    }

    return value;
}

export const switchcase = (value, defaultValue) => options => options[value] ? options[value] : defaultValue;

export const switchcaseF = (value, defaultValue) => options => switchcase(value, defaultValue)(options)();

export const getCurrentMonth = () => (new Date().getMonth() + 1);

export const makeArray = (length, createItem) => {
    let arr = [];
    for(let i = 0; i < length; i++) arr.push(createItem(i, arr));
    return arr;
}

export const doX = (times, fn, value) => {
    let last = value
    for(let i = 0; i < times; i++) last = fn(last, i);
    return last;
}

export const lpad = (str, len, pad = '0') => `${doX(len-(str+'').length, (l => `${pad}${l}`), '')}${str}`;

export const rpad = (str, len, pad = '0') => `${str}${doX(len-(str+'').length, (l => `${pad}${l}`), '')}`;

export const format = {
    monetario: (val) => {
        val = val + ""; //turn into string

        var signal = "";
        if(val.startsWith('-')) signal = '-';

        //Separar parte decimal
        var decimal = '';
        var comma = val.indexOf('.');
        if(comma >= 0){
            decimal = val.substring(comma).replace(/\D/g, '');
            val = val.substring(0, comma).replace(/\D/g, '');;
        }
        
        //garantir que a parte decimal tem 2 caracteres
        while(decimal.length < 2) decimal += '0';
            
        val = val.replace(/\D/g, ''); //remover tudo que não é digitos
        val = val.replace(/(^0{1,})/g, ''); //remover zeros a esquerda
        
        if(val.length === 0) val += '0'; //garantir pelo menos um zero antes da virgula
        
        while(val.match(/^\d{4}/) != null){ //enquanto tem quatro digitos seguidos sem nenhum ponto ou virgula
            val = val.replace(/^(\d+)(\d{3})/, '$1.$2'); //colcar um ponto entre o primeiro e os tres numeros seguintes
        }
 
        //Formatar (Sinal)Valor,Decimal
        return signal + val + "," + decimal;
    }
}

export const validaCpf = function(strCPF) {
    if(!strCPF || (typeof strCPF !== "string")) return false;

    strCPF = strCPF.replace(/\D/g, '');
    
    if (strCPF === "00000000000") return false;
    if (strCPF === "11111111111") return false;
    if (strCPF === "22222222222") return false;
    if (strCPF === "33333333333") return false;
    if (strCPF === "44444444444") return false;
    if (strCPF === "55555555555") return false;
    if (strCPF === "66666666666") return false;
    if (strCPF === "77777777777") return false;
    if (strCPF === "88888888888") return false;
    if (strCPF === "99999999999") return false;
    
    let soma = 0;
    for (let i=1; i<=9; i++) soma = soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
    let resto = (soma * 10) % 11;
   
    if ((resto === 10) || (resto === 11))  resto = 0;
    if (resto !== parseInt(strCPF.substring(9, 10)) ) return false;
   
    soma = 0;
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
    resto = (soma * 10) % 11;
   
    if ((resto === 10) || (resto === 11))  resto = 0;
    if (resto !== parseInt(strCPF.substring(10, 11) ) ) return false;

    return true;
}

export const validaCNPJ = function(cnpj) {
    if(!cnpj || (typeof cnpj !== "string")) return false;

    console.log(cnpj);
    cnpj = cnpj.replace(/\D/g, '');
    if(cnpj.length !== 14) return false;

    if(cnpj === '00000000000000') return false;
    if(cnpj === '11111111111111') return false;
    if(cnpj === '22222222222222') return false;
    if(cnpj === '33333333333333') return false;
    if(cnpj === '44444444444444') return false;
    if(cnpj === '55555555555555') return false;
    if(cnpj === '66666666666666') return false;
    if(cnpj === '77777777777777') return false;
    if(cnpj === '88888888888888') return false;
    if(cnpj === '99999999999999') return false;

    let dig1, dig2;
    
    let cons = [5,4,3,2,9,8,7,6,5,4,3,2];
    let soma = 0;
    for(let i = 0; i < 12; i++) {
        let a = parseInt(cnpj[i]);
        let b = cons[i];
        
        soma += (a * b);
    }

    let resto = soma%11;
    if(resto < 2) dig1 = 0;
    else dig1 = 11 - resto;


    soma = 0;
    cons = [6,5,4,3,2,9,8,7,6,5,4,3,2]
    for(let i = 0; i < 13; i++) {
        let a = parseInt(cnpj[i]);
        let b = cons[i];

        soma += (a * b);
    }

    resto = soma%11;
    if(resto < 2) dig2 = 0;
    else dig2 = 11-resto;

    
    console.log(cnpj);
    console.log(cnpj[12] + " " + cnpj[13]);
    console.log(dig1 + " " + dig2);

    return parseInt(cnpj[12]) === dig1 && parseInt(cnpj[13]) === dig2;
}

export const validaCodigoFolha = function(codigo) {
    if(!codigo || (typeof codigo !== "string")) return false;

    //Código deve conter no máximo 14 digitos
    if(codigo.length > 14) return false;

    //Código deve conter pelo menos 1 digito
    if(codigo.length < 1) return false;

    //Código deve conter apenas digitos e pontos
    if(codigo.match(/[^\d\.]/g)) return false;

    //Código aparenta ser um CPF válido, altere o tipo para Pessoa Física
    if(validaCpf(codigo)) return false;

    //Código aparenta ser um CNPJ válido, altere o tipo para Pessoa Jurídica
    if(validaCNPJ(codigo)) return false;

    //Codigo deve conter pelo menos um digito numérico
    codigo = codigo.replace(/\D/g, '');
    if(codigo.length <= 0) return false;

    return true;
}

export const isNumeric = value => !(value.match(/[^\d\.\,\-\+\=]/g));

export const showMessages = (alert, messages) => messages.forEach((msg) =>
    msg.code > 2999 ? alert.error(msg.description) :
    msg.code > 1999 ? alert.show(msg.description, {type: 'warning'}) :
    msg.code >  999 ? alert.show(msg.description) :
    alert.success(msg.description) 
);